// @ts-nocheck

import React, { useEffect } from 'react';
import styled from 'styled-components';

import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import BetFilterSelector from '../BetFilterSelector';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  display: block;
  margin: 0.6em 0;
`;

const StyledBetFilterSelector = styled(BetFilterSelector)`
  margin: 0 ${Target.__MOBILE__ ? '0.6em' : 0};
`;

const FirstSelector = styled(StyledBetFilterSelector)`
  background: ${theme.CatalogFilters.primaryBackground};

  &.selector-list {
    background-color: #1a1c24;
  }
`;

const SecondSelector = styled(StyledBetFilterSelector)`
  margin-top: 0.6em;
  background: ${theme.CatalogFilters.secondaryBackground};
  color: ${theme.CatalogFilters.color};
`;

type Filter = {
  id: number;
  label: string;
};

type BetFiltersProps = {
  className?: string;
  firstLevelFilters: Array<Filter>;
  secondLevelFilters: Array<Filter>;
  firstLevelId: number;
  secondLevelId: number;
  setFilter: (filterId: number | null) => void;
  fallbackId: null | null;
};

const BetFilters = ({
  className,
  firstLevelFilters,
  secondLevelFilters,
  firstLevelId,
  secondLevelId,
  setFilter,
  fallbackId,
}: BetFiltersProps) => {
  useEffect(() => {
    if (fallbackId !== null) {
      setFilter(fallbackId);
    }
  }, [fallbackId, setFilter]);

  useEffect(() => {
    return () => {
      setFilter(null);
    };
  }, [setFilter]);

  if (firstLevelFilters.length) {
    return (
      <Wrapper className={className} selecting={firstLevelId}>
        <FirstSelector
          options={firstLevelFilters}
          selectId={firstLevelId}
          defaultLabel={__('Filter bets')}
          onSelect={setFilter}
        />
        {secondLevelFilters.length > 0 ? (
          <SecondSelector
            options={secondLevelFilters}
            selectId={secondLevelId}
            onSelect={setFilter}
            noCancelButton
            isSecondary={true}
          />
        ) : null}
      </Wrapper>
    );
  }
  return null;
};

export default React.memo<BetFiltersProps>(BetFilters);
